<template>
  <div class="filterPanel">
    <h3 class="filterPanel__header filterPanel__header--topBorder">
      {{ titleText }}
      <span v-if="hasCount && items">({{ items ? items.length : 0 }})</span>
      <span class="filterPanel__hide"></span>
    </h3>
    <div class="filterPanel__inner">
      <div
        v-if="hasSearch"
        class="filterPanel__search"
      >
        {{ filterText }}
        <div class="filterPanel__searchFields">
          <input
            v-model="filterInput"
            class="filterPanel__filterAuthor"
            type="text"
            :title="searchPlaceholder"
            :placeholder="searchPlaceholder"
          >
          <div class="filterPanel__filterSubmit">
            <input
              class="filterPanel__filterSubmitInput"
              type="submit"
              value="Filter">
          </div>
        </div>
      </div>

      <ul class="filterPanel__items">
        <li
          v-for="(item, index) in itemsFiltered"
          :key="index"
          class="filterPanel__item"
        >
          <label class="filterPanel__label">
            <input
              v-model="checkboxesChecked"
              class="filterPanel__checkbox"
              type="checkbox"
              :name="`${fieldName}[]`"
              :value="parseInt(item.id, 10)"
              @change="checkboxClickHandler"
            >
            <span class="filterPanel__labelText">{{ item.title }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>


export default {
  props:
  {
    options: {
      type: Array,
      default: null,
    },
    titleText: {
      type: String,
      default: '',
    },
    fieldName: {
      type: String,
      default: '',
    },
    filterText: {
      type: String,
      default: 'Filter durchsuchen',
    },
    searchPlaceholder: {
      type: String,
      default: 'Suchbegriff',
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
    hasCount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: null,
      filterInput: '',
      inputCheckbox: null,
      checkboxesChecked: [],
    };
  },
  computed: {
    // a computed getter
    itemsFiltered()
    {
      if (!this.items) return [];

      if (this.hasSearch) {
        if (this.filterInput) {
          return this.items.filter(el => el.title.toLowerCase().indexOf(this.filterInput) !== -1);
        }
        else {
          return this.items;
        }
      } else {
        return this.items;
      }
    },
  },
  mounted()
  {
    // console.log('search filter panel - mounted');
    this.items   = [...this.options];
  },
  methods: {
    checkboxClickHandler()
    {
      this.$emit('filters-changed', this.fieldName, this.checkboxesChecked);
    },
  },
};

</script>

<style scoped lang="scss">
</style>
